import { Skeleton as MUISkeleton, styled } from '@mui/material'

export const Skeleton = styled(MUISkeleton)(({ theme }) => ({
  background: theme.palette.surface[900],
  marginBottom: theme.spacing(4),
}))
